export default __webpack_public_path__ + "static/media/book_diligence_a_teachings.c55a4324.png";